"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialModelYandex = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var i18n_1 = require("@dp-instant/i18n");
var interfaces_1 = require("@dp-instant/interfaces");
var social_1 = require("@dp-instant/social");
var utils_1 = require("@dp-instant/utils");
var inversify_1 = require("inversify");
var SocialModelYandex = (function (_super) {
    tslib_1.__extends(SocialModelYandex, _super);
    function SocialModelYandex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._userAuthorized = false;
        _this._friends = [];
        _this.leaderboards = [];
        _this._locale = "en_US";
        _this._tld = "com";
        return _this;
    }
    SocialModelYandex.prototype.startGameAsync = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var yasdk;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        yasdk = ((_a = this.pageModel.bus) === null || _a === void 0 ? void 0 : _a.params).yasdk;
                        this._yasdk = yasdk;
                        this._locale = this._determinateLocale();
                        i18n_1.Localize.defaultLocale = this._locale;
                        return [4, this.updateUserData(false)];
                    case 1:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    SocialModelYandex.prototype.init = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var initialcookiepromise, cookiedata, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.leaderboards.push(this._leaderboardGlobal);
                        this.leaderboards.push(this._leaderboardContext);
                        initialcookiepromise = this.cookie.get(["session"].concat((params === null || params === void 0 ? void 0 : params.cookies) || []));
                        _b = (_a = this.session).init;
                        return [4, initialcookiepromise];
                    case 1:
                        cookiedata = _b.apply(_a, [(_c.sent()).session]);
                        this.cookie.save("session", cookiedata);
                        return [4, this.payments.init({ yasdk: this._yasdk })];
                    case 2:
                        _c.sent();
                        return [2];
                }
            });
        });
    };
    Object.defineProperty(SocialModelYandex.prototype, "me", {
        get: function () {
            return this._me;
        },
        enumerable: false,
        configurable: true
    });
    SocialModelYandex.prototype.updateUserData = function (scopes) {
        if (scopes === void 0) { scopes = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var player, modelChanged, userAuthorized, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modelChanged = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this._yasdk.getPlayer({ scopes: scopes })];
                    case 2:
                        player = _a.sent();
                        userAuthorized = player.getMode() !== "lite";
                        if (this._userAuthorized !== userAuthorized) {
                            this._userAuthorized = userAuthorized;
                            modelChanged = true;
                        }
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        utils_1.log.warn(e_1);
                        return [3, 4];
                    case 4:
                        this._me || (this._me = core_1.di.get(interfaces_1.TypesSocial.user));
                        this._me.init(player || core_1.di.get(interfaces_1.TypesSocial.dummyUser));
                        this.cookie.init(player);
                        if (modelChanged) {
                            this.emit("AUTHORIZATION_STATE_CHANGED");
                        }
                        return [2];
                }
            });
        });
    };
    SocialModelYandex.prototype.authorizeUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this._userAuthorized) return [3, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, this._yasdk.auth.openAuthDialog()];
                    case 2:
                        _a.sent();
                        return [4, this.updateUserData(true)];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        e_2 = _a.sent();
                        utils_1.log.warn(e_2);
                        return [3, 5];
                    case 5: return [2, this._userAuthorized];
                }
            });
        });
    };
    SocialModelYandex.prototype.postSessionScore = function (score) {
        return tslib_1.__awaiter(this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2];
        }); });
    };
    Object.defineProperty(SocialModelYandex.prototype, "friends", {
        get: function () {
            return this._friends;
        },
        enumerable: false,
        configurable: true
    });
    SocialModelYandex.prototype.getFriendById = function (id, friends) {
        var e_3, _a;
        friends = friends || this._friends;
        if (id === this._me.id) {
            return this._me;
        }
        try {
            for (var friends_1 = tslib_1.__values(friends), friends_1_1 = friends_1.next(); !friends_1_1.done; friends_1_1 = friends_1.next()) {
                var f = friends_1_1.value;
                if (f.id === id) {
                    return f;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (friends_1_1 && !friends_1_1.done && (_a = friends_1.return)) _a.call(friends_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    Object.defineProperty(SocialModelYandex.prototype, "socialPlatform", {
        get: function () {
            return "ya";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SocialModelYandex.prototype, "userAuthorized", {
        get: function () {
            return this._userAuthorized;
        },
        enumerable: false,
        configurable: true
    });
    SocialModelYandex.prototype.syncLeaderboards = function () {
        var _a, _b, _c, _d;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var scoreBackend, extraDataBackend, scoreYandex, yandexExtraData, _e, _f;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!!this.userAuthorized) return [3, 2];
                        return [4, this._leaderboardContext.sync()];
                    case 1:
                        _g.sent();
                        return [3, 14];
                    case 2: return [4, this._leaderboardContext.sync()];
                    case 3:
                        _g.sent();
                        scoreBackend = this.me.scoreGlobal;
                        extraDataBackend = (_b = (_a = this.me.scores) === null || _a === void 0 ? void 0 : _a.getEntry(social_1.ScoreType.GLOBAL)) === null || _b === void 0 ? void 0 : _b.getExtraData();
                        return [4, this._leaderboardGlobal.sync()];
                    case 4:
                        _g.sent();
                        scoreYandex = this.me.scoreGlobal;
                        yandexExtraData = (_d = (_c = this.me.scores) === null || _c === void 0 ? void 0 : _c.getEntry(social_1.ScoreType.GLOBAL)) === null || _d === void 0 ? void 0 : _d.getExtraData();
                        if (!(scoreBackend > scoreYandex)) return [3, 9];
                        if (!extraDataBackend) return [3, 6];
                        return [4, this._leaderboardGlobal.submit(scoreBackend, extraDataBackend)];
                    case 5:
                        _e = _g.sent();
                        return [3, 8];
                    case 6: return [4, this._leaderboardGlobal.submit(scoreBackend)];
                    case 7:
                        _e = _g.sent();
                        _g.label = 8;
                    case 8:
                        _e;
                        return [3, 14];
                    case 9:
                        if (!(scoreYandex > scoreBackend)) return [3, 14];
                        if (!yandexExtraData) return [3, 11];
                        return [4, this._leaderboardContext.submit(scoreYandex, yandexExtraData)];
                    case 10:
                        _f = _g.sent();
                        return [3, 13];
                    case 11: return [4, this._leaderboardContext.submit(scoreYandex)];
                    case 12:
                        _f = _g.sent();
                        _g.label = 13;
                    case 13:
                        _f;
                        _g.label = 14;
                    case 14: return [2];
                }
            });
        });
    };
    Object.defineProperty(SocialModelYandex.prototype, "sdk", {
        get: function () {
            return this._yasdk;
        },
        enumerable: false,
        configurable: true
    });
    SocialModelYandex.prototype._determinateLocale = function () {
        var _a, _b;
        var locale = "en_US";
        var i18n = (_b = (_a = this._yasdk) === null || _a === void 0 ? void 0 : _a.environment) === null || _b === void 0 ? void 0 : _b.i18n;
        if (i18n) {
            var yandexSDKEnvCode = i18n.lang;
            var tld = i18n.tld;
            this._tld = tld ? tld : this._tld;
            switch (yandexSDKEnvCode) {
                case "ru":
                case "be":
                case "kk":
                case "uk":
                case "uz":
                    locale = "ru_RU";
                    break;
                case "tr":
                    locale = "tr_TR";
                    break;
                case "es":
                    locale = "es_ES";
                    break;
                case "pt":
                    locale = "pt_BR";
                    break;
                case "hi":
                    locale = "hi_IN";
                    break;
                case "ar":
                    locale = "ar_AR";
                    break;
                case "ja":
                    locale = "ja_JP";
                    break;
                case "fr":
                    locale = "fr_FR";
                    break;
                case "id":
                    locale = "id_ID";
                    break;
                case "de":
                    locale = "de_DE";
                    break;
                case "it":
                    locale = "it_IT";
                    break;
                case "zh":
                    locale = "zh_CN";
                    break;
            }
        }
        return locale;
    };
    Object.defineProperty(SocialModelYandex.prototype, "locale", {
        get: function () {
            return this._locale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SocialModelYandex.prototype, "tld", {
        get: function () {
            return this._tld;
        },
        enumerable: false,
        configurable: true
    });
    SocialModelYandex.prototype.switchGame = function (id, data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                window.open("//yandex.".concat(this.tld, "/games/app/").concat(id));
                return [2];
            });
        });
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesApp.pageModel),
        tslib_1.__metadata("design:type", social_1.PageModel)
    ], SocialModelYandex.prototype, "pageModel", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.leaderboardGlobal),
        tslib_1.__metadata("design:type", Object)
    ], SocialModelYandex.prototype, "_leaderboardGlobal", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.leaderboardContext),
        tslib_1.__metadata("design:type", Object)
    ], SocialModelYandex.prototype, "_leaderboardContext", void 0);
    SocialModelYandex = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], SocialModelYandex);
    return SocialModelYandex;
}(social_1.SocialModelBase));
exports.SocialModelYandex = SocialModelYandex;
//# sourceMappingURL=SocialModelYandex.js.map